import { render, staticRenderFns } from "./AboutAPP.vue?vue&type=template&id=29a20934&scoped=true&"
import script from "./AboutAPP.vue?vue&type=script&lang=js&"
export * from "./AboutAPP.vue?vue&type=script&lang=js&"
import style0 from "./AboutAPP.vue?vue&type=style&index=0&id=29a20934&prod&lang=scss&"
import style1 from "./AboutAPP.vue?vue&type=style&index=1&id=29a20934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a20934",
  null
  
)

export default component.exports